<template>
  <el-row :gutter="15">
    <el-col
      :xs="7"
      :sm="6"
      :md="6"
      :lg="5"
      :xl="5"
    >
      <Filters
        v-model="filters"
        :resource="$sdk.attachment"
        :primary-fields="[ 'file.name', 'file.type', 'file.creator', 'created_at' ]"
        @apply="$refs.table.loadTable()"
        @ready="$refs.table.loadTable()"
      />
    </el-col>

    <el-col
      :xs="17"
      :sm="18"
      :md="18"
      :lg="19"
      :xl="19"
    >
      <el-card
        shadow="never"
      >
        <AttachmentsTable
          ref="table"
          :account-id="$route.params.accountId"
          :filters="filters"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Filters from '@/components/Filters/Simplified'
import AttachmentsTable from '@/components/Application/Manage/Account/AttachmentsTable'

export default {
  components: {
    Filters,
    AttachmentsTable
  },
  data () {
    return {
      actions: [],
      breadcrumb: {
        name: 'Attachments',
        route: { name: 'manage-accounts-account-attachments', params: { accountId: this.$route.params.accountId } }
      },
      filters: []
    }
  },
  mounted () {
    this.actions = this.$refs.table.actions
  }
}
</script>
